import { container, title } from "assets/jss/material-kit-react.js";
import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.js";

const menuStyle = theme => ({
  section: {
    padding: "10px 0 !important",
    paddingTop: "10px !important",
    textAlign:"center",
    backgroundColor: "rgb(217 218 204)",
    color: "rgb(92 86 67)"
  },
  navLink: {
    color: "inherit",
    position: "relative",
    padding: "0.9375rem",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    "&:hover,&:focus": {
      color: "inherit",
      background: "rgba(200, 200, 200, 0.1)"
    },
     [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start"
      }
    }
  },
  subNavLinkActive: {
    color: "inherit",
    backgroundColor: "rgba(255, 255, 255, 0.4)"
  },
  topSection: {
    padding: "10px 0 !important",
    textAlign:"center",
    backgroundColor:"#027a42!important",
    color:"#fff"
  },
  ...headerLinksStyle(theme),
  listItem: {
    display:"initial",
    float:"none"
  },
  '@media screen and (max-width: 960px)': {
    listItem: {
      display:"block",
      float:"none"
    },
  },
  hidden:{
    display:"none"
  }
});

export default menuStyle;
